/** @jsxImportSource @emotion/react */
import { motion } from 'framer-motion';
import Imgix from 'react-imgix';
import { H2 } from '../../Typography';
import { Button } from '../../UI';
import useStyle from './style';

const SimpleSteps: React.FC<{
  noCta?: boolean;
  href?: string;
  ctaText?: string;
}> = ({ noCta, href = '/quiz/', ctaText = 'Choose My Equipment' }) => {
  const {
    componentContainer,
    componentWrapper,
    stepsWrapper,
    stepStyle,
    ctaStyle,
    stepImgStyle,
  } = useStyle();

  const steps = [
    {
      image: {
        url: 'https://www.datocms-assets.com/10154/1725891647-secure-your-home-step-1.png',
        alt: 'alarm equipments',
      },
      step: 'Make it yours',
    },
    {
      image: {
        url: 'https://www.datocms-assets.com/10154/1680545027-women-installing-window-sensors-copy.png',
        alt: 'Woman installing window sensor',
      },
      step: 'Set it up in minutes',
    },
    {
      image: {
        url: 'https://www.datocms-assets.com/10154/1687191051-woman-disarming-panel.png',
        alt: 'Woman disarming panel',
      },
      step: 'Count on us',
    },
  ];

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.125,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 25, transition: { type: 'spring' } },
    show: { opacity: 1, y: 0, transition: { type: 'spring' } },
  };

  return (
    <div css={componentContainer}>
      <div css={componentWrapper}>
        <H2>Secure your home in 3 simple steps.</H2>
        <motion.div
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          css={stepsWrapper}
        >
          {steps.map((step, stepIndex) => (
            <motion.div
              key={`step-${stepIndex}`}
              variants={item}
              css={stepStyle}
            >
              <Imgix
                src={step.image.url}
                htmlAttributes={{ alt: step.image.alt, loading: 'lazy' }}
                width={350}
                height={189}
                css={stepImgStyle}
              />
              <p className="text-lg">
                <b>{stepIndex + 1}.</b> {step.step}
              </p>
            </motion.div>
          ))}
        </motion.div>
        {!noCta && (
          <div css={ctaStyle}>
            <Button
              id="ctaSectionSteps"
              cypressId="ctaSectionSteps"
              href={href}
              size="large"
              color="purple"
              style="container"
            >
              {ctaText}
            </Button>
            <p>Takes less than 1 minute</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimpleSteps;
